import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
    
      <p>Todos los derechos reservados.</p>
      <p>Atención al cliente: 0800-SAPO</p>
      <p>OSECROACK</p>
    
    </footer>
  );
};

export default Footer;